import { useState, useEffect } from 'react';

function useShouldRender(isOpen) {
    const [shouldRenderChildren, setShouldRenderChildren] = useState(isOpen);
    useEffect(() => {
        let timeout;
        if (isOpen) {
            setShouldRenderChildren(true);
        }
        else {
            timeout = window.setTimeout(() => {
                setShouldRenderChildren(false);
            }, 200);
        }
        return () => {
            clearTimeout(timeout);
        };
    }, [isOpen]);
    return !!isOpen || !!shouldRenderChildren;
}

export { useShouldRender };
//# sourceMappingURL=useShouldRender.esm.js.map
